import { type JSX } from 'solid-js';
import AdminTopbar from './AdminTopbar';
import { useMobileSidebar } from '../hooks/useMobileSidebar';

export default function AdminLayout(props: { children: JSX.Element }) {
  const { toggleSidebar } = useMobileSidebar();

  const hamburger = (
    <button class="hamburger-btn" onClick={toggleSidebar} aria-label="Toggle sidebar">
      <i class="fa-solid fa-bars"></i>
    </button>
  );

  return (
    <AdminTopbar menuButton={hamburger}>
      {props.children}
    </AdminTopbar>
  );
}
